import { supabase } from '@/integrations/supabase/client';

// Définir et exporter la constante utilisée par databaseService.ts
export const ESCORT_PHOTOS_BUCKET = 'escort-photos';

export const initializeStorage = async () => {
  console.log("Storage initialization skipped (bucket assumed to exist).");
  return Promise.resolve();
};

export const uploadImageFile = async (profileId: string, file: File) => {
  try {
    // Create a unique file path
    const fileExt = file.name.split('.').pop();
    const fileName = `${profileId}/${Date.now()}.${fileExt}`;
    
    // Upload the file
    const { data, error } = await supabase.storage
      .from(ESCORT_PHOTOS_BUCKET) // Utiliser la constante ici
      .upload(fileName, file, {
        cacheControl: '3600',
        upsert: false,
      });
    
    if (error) throw error;
    
    // Get the public URL
    const { data: urlData } = supabase.storage
      .from(ESCORT_PHOTOS_BUCKET) // Utiliser la constante ici
      .getPublicUrl(fileName);
    
    return {
      success: true,
      url: urlData.publicUrl,
      path: fileName,
    };
  } catch (error) {
    console.error('Error uploading image:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
};

// Fonction exportée avec le nom attendu par databaseService.ts
export const deleteStorageFile = async (filePath: string, bucketName: string = ESCORT_PHOTOS_BUCKET) => {
  try {
    const { error } = await supabase.storage
      .from(bucketName)
      .remove([filePath]);
    
    if (error) throw error;
    
    return true;
  } catch (error) {
    console.error(`Error deleting file from bucket ${bucketName}:`, error);
    return false;
  }
};

// Garder la fonction originale pour la compatibilité
export const deleteImage = async (filePath: string) => {
  return deleteStorageFile(filePath, ESCORT_PHOTOS_BUCKET);
};
